import React, { FC, useState } from 'react';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { Employee } from '~/types';
import { FlashIcon } from '~/img';
import { Drawer, Form } from '~/components';
import { phoneValidation } from '~/utils';
import { usePermissions } from '~/hooks';
import { useEmployeesAccessCode } from '~/hooks/employees';
import PhoneInput from '~/components/PhoneInput';

interface Props {
  record: Employee;
}

const EmployeeGetAccessCode: FC<Props> = (props) => {
  const { record } = props;
  const [t] = useTranslation('employees');
  const dt = (key: string): string => t(`translation:${key}`);

  const { mutate, accessCode, resetAccessCode, isLoading } = useEmployeesAccessCode();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    resetAccessCode();
    setOpen(false);
  };

  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    const { phone } = values;
    mutate({ id: record.id, phone });
  };

  const hasAccess = usePermissions('business.employee.get access code');
  if (!hasAccess) return null;
  if (!record) return null;
  return (
    <>
      <Button onClick={handleOpen} icon={<FlashIcon />}>
        {t('getAccessCode')}
      </Button>
      <Drawer
        title={t('getAccessCodeFor', { name: `${record.firstName} ${record.lastName}` })}
        onClose={handleClose}
        visible={open}
      >
        {accessCode ? (
          <>
            <Typography.Title level={3}>{accessCode}</Typography.Title>
            <Typography.Text type="secondary">{t('accessCodeMessage')}</Typography.Text>
          </>
        ) : (
          <Form
            form={form}
            layout="vertical"
            initialValues={{ phone: record.phoneNumber }}
            onFinish={onFinish}
          >
            <Form.Item name="phone" rules={[{ validator: phoneValidation }]}>
              <PhoneInput style={fullWidth} placeholder={dt('phoneNumber')} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isLoading} icon={<FlashIcon />}>
                {t('getAccessCode')}
              </Button>
            </Form.Item>
          </Form>
        )}
      </Drawer>
    </>
  );
};

const fullWidth = { width: '100%' };

export default EmployeeGetAccessCode;
